import GlobalStyle from "../../styles/GlobalStyle";
import { FontSizes } from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { getStatusStyles } from "../../utils/helpers/dentalHelper";

const StatusLabel = ({ lable }: { lable: any }) => {
  const { backgroundColor, color } = getStatusStyles(lable);

  return (
    <div style={{ ...V2ReportStyle.label, backgroundColor }}>
      <span
        style={{
          ...GlobalStyle.blackBoldText,
          fontSize: "1.5rem",
          color,
        }}
      >
        {lable}
      </span>
    </div>
  );
};

export default StatusLabel;
